<template>
  <div class="row-controls border border-gray-200 rounded-r gap-4" style="filter:none !important;">
    <span class="text-secondary mx-auto title-right" title="Row index (used for troubleshooting in conjunction with user logs)">
      {{ index }}
    </span>

    <hr>

    <span v-if="selectable" class="text-danger">
      <input type="checkbox" @change="$parent.$parent.toggleBulkIndex(index)" :checked="$store.state.hasOwnProperty('exportDetails') ? $store.state.exportDetails.current.bulkSelection[fieldName].indexOf(index) > -1 : false">
    </span>

    <hr v-if="selectable">

    <span @click.prevent="trashConfirmBox = true" class="text-danger">
      <i class="fa fa-trash"></i>
      <confirm-box
          :show="trashConfirmBox"
          :content="`Are you sure you want to remove this modification?`"
          button="Delete"
          @cancel="trashConfirmBox = false"
          @confirm="removeRulesRow(index); trashConfirmBox = false;"
      />
    </span>
    <hr>
    <span v-show="!value.disabled"  @click.prevent="disableConfirmBox = true" class="text-info">
      <i class="fa fa-eye"></i>
      <confirm-box
          :show="disableConfirmBox"
          :content="`Are you sure you want to disable this modification?`"
          button="Disable"
          @cancel="disableConfirmBox = false"
          @confirm="disableRulesRow(index)"
      />
    </span>
    <span v-show="value.disabled"  @click.prevent="disableRulesRow()" class="text-secondary" style="filter:grayscale(0%) brightness(1) opacity(1);">
      <i class="fa fa-eye-slash"></i>
    </span>
  </div>
</template>

<script>
import ConfirmBox from '../ui-components/ConfirmBox'
export default {
  name: "LogicFieldControls",
  components: {ConfirmBox},
  props: {
    storeRemoveMethod: {default: 'REMOVE_PROP_FROM_META_DATA'},
    value: {required: true},
    index: {required: true},
    selectable: {default: false},
    fieldName: {
      required: true,
      type: String,
    }
  },
  data() {
    return {
      disableConfirmBox: false,
      trashConfirmBox: false,
    }
  },
  methods: {
    removeRulesRow() {
      if (window.location.href.indexOf('export-details') > -1) {
        this.$store.commit(`exportDetails/${this.storeRemoveMethod}`, {
          key: this.fieldName,
          index: this.index
        });
      }

      if (window.location.href.indexOf('export-details') > -1) {
        this.$store.commit(`exportDetails/UPDATE_CURRENT_DELETED_ITEMS`, {
          key: this.fieldName,
          index: this.index,
          value: this.value
        });
      }
    },
    disableRulesRow() {
      this.disableConfirmBox = false;
      this.value.disabled = !this.value.disabled

      if (window.location.href.indexOf('export-details') > -1) {
        this.$store.commit('exportDetails/UPDATE_CURRENT_META_DATA_FOR_KEY', {
          key: this.fieldName,
          index: this.index,
          value: this.value
        });
      }

      this.$store.commit(`exportDetails/UPDATE_CURRENT_DISABLED_ITEMS`, {
        key: this.fieldName,
        index: this.index,
        value: this.value.disabled
      });
    }
  },
  watch: {
    value() {
      this.$dispatch('update:value', this.value)
    }
  }
}
</script>

<style scoped>
  .row-controls {
    position: absolute;
    right: -30px;
    top: 0;
    bottom: 0;
    padding: 0 5px;
    display: flex;
    flex-direction: column;
    background: rgba(0,0,0,.05);
    justify-content: center;
    height: 100%;
  }
  
  .text-danger, .text-info {
    position: relative;
  }
  .fa-eye:hover, .fa-trash:hover{
    opacity: .5;
    cursor: pointer;
  }
  .text-info {
    color: #17a2b8;
  }

</style>